export const SET_USER = 'SET_USER';
export const LOGIN_REQUEST = 'LOGIN_REQUEST'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'
export const CLEAR_PASSWORD_CHANGE_REQUIRED = 'CLEAR_PASSWORD_CHANGE_REQUIRED';
export const SET_DEPLOYMENT_TYPE = 'SET_DEPLOYMENT_TYPE';
